import React from "react";
import {Avatar, Box, Button, Flex, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList} from "@chakra-ui/react";
import {ReactComponent as Logo} from "../../assets/icons/logo_text.svg";
import {ReactComponent as MobileLogo} from "../../assets/icons/mobileLogo.svg";
import {ReactComponent as LanguageIcon} from "../../assets/icons/language_icon.svg";
import {ReactComponent as MenuIcon} from "../../assets/icons/mobileMenuIcon.svg";
import {ReactComponent as LightIcon} from "../../assets/icons/light_icon.svg";
import {ReactComponent as Notification} from "../../assets/icons/bell-notification.svg";
import {ReactComponent as SearchIcon} from "../../assets/icons/search_icon_white.svg";
import {StyledButton} from "../index";
import {Link, useNavigate} from "react-router-dom";


const Links = ['Tools', 'About', 'Learn', 'Plans', 'Blog']
const url = ['tools', 'about', 'tutorials', 'plans', 'blog']
const NavLink = (props) => {
    const {children, to} = props
    return (
        <Box
            as={Link}
            fontSize={'18px'}
            color={'white'}
            _hover={{
                textDecoration: 'none',
            }}
            to={'/' + to.toLowerCase()}>
            {children}
        </Box>
    )
}

const MobileNav = () => {
    return (
        <HStack
            w={'full'}
            justifyContent={'space-between'}
            as={'nav'}
            m={'auto'}
            px={'24px'}>
            <HStack>
                <MobileLogo/>
            </HStack>
            <Menu>
                <MenuButton
                    as={IconButton}
                    icon={<MenuIcon/>}
                    aria-label="Toggle Menu"
                    bg={'transparent'}
                    color={'neutral.100'}
                />
                <MenuList>
                    {Links.map((link,index) => (
                        <MenuItem key={link}>{link}</MenuItem>
                    ))}
                </MenuList>
            </Menu>
        </HStack>
    );
};

const DesktopNav = ({user}) => {
    const navigate = useNavigate()

    return (
        <>
            <HStack>
                <Logo width={user ? '130px' : '180px'} onClick={() => navigate('/')} style={{cursor: 'pointer'}}/>
            </HStack>
            {/*<Box*/}
            {/*    bg={'linear-gradient(180deg, rgba(88, 52, 168, 0.7) 0%, rgba(255, 255, 255, 0) 100%)'}*/}
            {/*    left={'197px'}*/}
            {/*    backdropFilter={'blur(200px)'}*/}
            {/*    position={'absolute'}*/}
            {/*    w={'886px'}*/}
            {/*    h={'384px'}*/}
            {/*    top={'80px'}*/}
            {/*    borderRadius={'592px'}*/}
            {/*    m={'auto'}*/}
            {/*    opacity={'0.75'}/>*/}
            <HStack
                as={'nav'}
                w={'539px'}
                m={'auto'}
                gap={'48px'}>
                {Links.map((link,index) => (

                    <NavLink key={link} to={url[index]}>
                        {link}
                    </NavLink>
                ))}
            </HStack>
            {
                user ? (
                    <HStack spacing={'24px'}>
                        <Flex
                            w={'40px'}
                            h={'40px'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            borderRadius={'8px'}
                            bg={'neutral.900'}>
                            <SearchIcon/>
                        </Flex>
                        <HStack spacing={'16px'}>
                            <LanguageIcon/>
                            <LightIcon/>
                            <Notification/>
                        </HStack>
                        <Avatar
                            cursor={'pointer'}
                            onClick={() => navigate('/profile')}
                            name='Dan Abrahmov'
                            src='https://bit.ly/dan-abramov'/>
                    </HStack>
                ) : (
                    <HStack
                        w={'258px'}
                        gap={'24px'}>
                        <Menu>
                            <MenuButton
                                _hover={''}
                                zIndex={'999999999'}
                                _active={''}
                                bg={'transparent'}
                                color={'neutral.100'}
                                as={Button}
                                leftIcon={<LanguageIcon/>}>
                                EN
                            </MenuButton>
                        </Menu>
                        <StyledButton as={Link} to={'/auth/register'} fontSize={'body.md'}>
                            Get Started
                        </StyledButton>
                    </HStack>
                )
            }
        </>
    )
}

export {
    DesktopNav,
    MobileNav
};